module.exports = __webpack_public_path__ + "static/img/partner-gjny.8953ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-gjny.png
// module id = hb+n
// module chunks = 34